import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("sobota 24. 5. 2025"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" obtížnost  – WW 1 – WW 2+")
  ]),
  /*#__PURE__*/_createElementVNode("h3", { class: "sold-out" }, "Zrušeno"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nebezpečné jezy, jezy smrťáky, uvíznutí na koruně jezu, protože je málo vody. Všechno toto je pravda, ale NE na této řece. Bystřička je řeka, která všechny tyto skutečnosti mění jen v pověry. Na úseku 7 kilometrů, 20 sjízdných jezů a splavů. Tomu se říká říční rodeo. Tak neváhejte a pojďte si toto rodeo vyzkoušet s námi. Vzhledem k tomu, že jednou je málo a třikrát je moc, tak si tuto řeku sjedeme dvakrát. První jízda bude taková oťukávačka. Každý z 20 skoků potřebuje jinou trajektorii splutí a hlavně, jinou nájezdovou rychlost. Jednotlivé skoky jsou vysoké v rozmezí 0,5 metru až 3 metry. Máte pocit, že přeháníme, tak se přesvědčte osobně. Kdo nezažil, nepochopí. Začátek plavby bude hned pod hrází přehrady Bystřička, konec naši plavby je po sedmi kilometrech uprostřed stejnojmenné obce. Po prvním, cvičném, splutí zde zabalíme saky, paky a vyrazíme zpět pod hráz, nafoukáme lodě a fičíme k vodě. Tentokrát už to bude ovšem jízda se vší parádou. Po doplutí k našemu cíli pobalíme lodě, hodíme se do gala, dáme pivko a klobásu…no a zas tu bude konec jedné super, střeštěné akce. Plavit se budeme na 2 (Baraka) – 6 (Colorado) místných raftech. V přihlášce uveďte, na jakém typu lodi chcete jet. Zkušeným vodákům doporučujeme pro větší požitek dvojky, ale kdo si není úplně jistý v kramflecích, by měl, pro klid náš i váš, jet na šestce, ve které může sedět, dle přání, i jeden z naších zkušených instruktorů. SK CAPP varuje před užíváním alkoholu a omamných látek před a při jízdě v lodi. Ohrožujete tím život váš, i všech okolo. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Sraz – sobota 24.5. v 7.30 hod na autobusovém nádraží Frýdek, odjezd v 8.00 hod"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Plánovaný návrat v 14 - 15 hod tamtéž")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "center" }, " Cena: 900.-Kč "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createTextVNode(" V ceně: "),
    /*#__PURE__*/_createElementVNode("li", null, "Cesta autobusem FM – Bystřička – a zpět"),
    /*#__PURE__*/_createElementVNode("li", null, "Lodě, pádla, vesty, helmy, technické zázemí"),
    /*#__PURE__*/_createElementVNode("li", null, "Instruktoři vodní turistiky"),
    /*#__PURE__*/_createElementVNode("li", null, "Startovné"),
    /*#__PURE__*/_createTextVNode(" V ceně není: "),
    /*#__PURE__*/_createElementVNode("li", null, " Pojištění – doporučujeme pojištění na cestu a pobyt, rafting + pojištění zodpovědnosti za škody způsobené jiné osobě "),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Neoprén – kdo chce, může si jej vypůjčit u nás. Uveďte v objednávce.  100,- / den "),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, " Uvádějte velikosti  od S až po XXL. Pro zájemce máme i neoprenové boty. "),
        /*#__PURE__*/_createElementVNode("li", null, "Rovněž nám napište velikost. 30.-Kč / den")
      ])
    ])
  ])
], -1)

import CommonPage from "@/components/CommonPage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Bystricka',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "BYSTŘIČKA 2025" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})